import qs from 'qs';
import request from '@/config/request';

/*
  获取会员列表
  userName, userPhone, integralMin, integralMax，beginTime，endTime，
*/
export function getUserList({ page, pageSize, ...rest }) {
  return request({
    url: `/user/getUserList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查询导出
  userName, userPhone，integralMin，integralMax，beginTime，endTime
*/
export function excelPort(rest) {
  return request({
    url: '/user/export',
    method: 'get',
    params: rest,
    responseType: 'blob',
  });
}

/*
  会员详情
  id
*/
export function getUser(id) {
  return request({
    url: 'user/getUser',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  修改会员信息表
  id,userName,userSex,userBirthday,userCity,userPhone,userEmail,code
*/
export function updateUser(rest) {
  return request({
    url: 'user/updateUser',
    method: 'post',
    data: qs.stringify(rest),
  });
}

export function addUser(rest) {
  return request({
    url: 'user/addUserByPc',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查询会员卡配置列表
*/
export function getUserCard() {
  return request({
    url: 'user/getUserCard',
    method: 'post',
  });
}

/*
  添加会员卡
  cardUrl,showCigar,showBoutique,showPersonalMade
*/
export function addUserCard(rest) {
  return request({
    url: 'user/addUserCard',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  修改会员卡
  id,cardUrl,showCigar,showBoutique,showPersonalMade
*/
export function updateUserCard(rest) {
  return request({
    url: 'user/updateUserCard',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  会员上下架
*/
export function updateUserCardUpAndDown() {
  return request({
    url: 'user/updateUserCardUpAndDown',
    method: 'post',
  });
}

/*
  积分记录分页列表
  id,cardUrl,showCigar,showBoutique,showPersonalMade
*/
export function getAppIntegralRecordList({ page, pageSize, ...rest }) {
  return request({
    url: `user/getAppIntegralRecordList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}
